import React, {ReactNode} from 'react';
import style from './Content.module.css'

interface IContent {
    children: ReactNode
}



const Content = ({children}: IContent) => {

    return (
        <main className={style.main}>
                {children}
        </main>

    );
};

export default Content;